import {createRouter, createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SettingView from "@/views/SettingView";
import ProductView from "@/views/ProductView";
import CategoryView from "@/views/CategoryView";
import LoginView from "@/views/LoginView";
import store from '@/store/index'
import OrdersView from "@/views/OrdersView";
import RoomView from "@/views/Management/RoomView";
import RoleView from "@/views/Management/RoleView";
import UserView from "@/views/Management/UserView";
import SliderView from "@/views/Management/SliderView.vue";
import SurveyQuestionView from "@/views/Management/SurveyQuestionView.vue";
import SurveyView from "@/views/Management/SurveyView.vue";
import LanguageView from "@/views/Management/LanguageView.vue";

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: LoginView,
        meta: {
            auth: true
        }
    },
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            auth: false
        }
    },
    {
        path: '/orders/:type',
        name: 'Orders',
        component: OrdersView,
        meta: {
            auth: true
        }
    },
    {
        path: '/setting',
        name: 'Setting',
        component: SettingView,
        meta: {
            auth: false
        },
        children: [
            {
                path: 'product/:type',
                name: 'Product',
                component: ProductView,
                meta: {
                    auth: true
                }
            },
            {
                path: 'category/:type',
                name: 'Category',
                component: CategoryView,
                meta: {
                    auth: true
                }
            },
            {
                path: 'room',
                name: 'Room',
                component: RoomView,
                meta: {
                    auth: true
                }
            },
            {
                path: 'role',
                name: 'Role',
                component: RoleView,
                meta: {
                    auth: true
                }
            },
            {
                path: 'user',
                name: 'User',
                component: UserView,
                meta: {
                    auth: true
                }
            },
            {
                path: 'slider',
                name: 'Slider',
                component: SliderView,
                meta: {
                    auth: true
                }
            },
            {
                path: 'survey-question',
                name: 'SurveyQuestion',
                component: SurveyQuestionView,
                meta: {
                    auth: true
                }
            },
            {
                path: 'survey',
                name: 'Survey',
                component: SurveyView,
                meta: {
                    auth: true
                }
            },
            {
                path: 'language',
                name: 'Language',
                component: LanguageView,
                meta: {
                    auth: true
                }
            },
        ]
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.name === 'Login')) {
        next()
    } else {
        if (store.getters.isLoggedIn) {
            if (store.state.user.role.type === 'admin') {
                next()
            } else {
                if (!to.meta.auth) {
                    if (to.path === '/') {
                        if (store.state.user.role.type === 'reception' || store.state.user.role.type === 'housekeeping') {
                            next()
                        }
                    } else {
                        next()
                    }
                } else {
                    if ((to.path === '/orders/restaurant' || to.path === '/setting/product/restaurant') && store.state.user.role.type === 'restaurant') {
                        next()
                    } else if ((to.path === '/orders/shop' || to.path === '/setting/product/shop') && store.state.user.role.type === 'shop') {
                        next()
                    } else if ((to.path === '/orders/caffe' || to.path === '/setting/product/caffe') && store.state.user.role.type === 'caffe') {
                        next()
                    }
                }
            }
        } else {
            next({path: '/login'})
        }
    }
})
export default router
